import {
  MOTIVO_CODIGOS_ESTABLECIMIENTO,
  VerificacionDato,
} from '../interfaces/verificacion-datos.interface'

export const ETIQUETA_VERIFICAR = 'Verificar datos'

export const ETIQUETA_SIN_PENDIENTES = 'Sin pendientes'

export const verificacionesPendientesDe = (
  verificaciones: Array<VerificacionDato> | null | undefined,
  identidad: any
): Array<VerificacionDato> => {
  const identificador = Number(identidad)
  if (!Array.isArray(verificaciones) || !identificador) return []
  return verificaciones.filter(
    (verificacion) => verificacion.pendiente && Number(verificacion.identidad) === identificador
  )
}

export const tituloMotivos = (verificaciones: Array<VerificacionDato>): string =>
  verificaciones.map((verificacion) => verificacion.titulo).join(' | ')

export const resumenParaTooltip = (verificaciones: Array<VerificacionDato>): string => {
  if (verificaciones.length === 0) return ETIQUETA_SIN_PENDIENTES
  return verificaciones
    .map((verificacion) =>
      verificacion.querevisar
        ? `${verificacion.titulo}: ${verificacion.querevisar}`
        : verificacion.titulo
    )
    .join('. ')
}

export const faltanCodigosEstablecimiento = (
  verificaciones: Array<VerificacionDato> | null | undefined
): boolean =>
  Array.isArray(verificaciones) &&
  verificaciones.some(
    (verificacion) =>
      verificacion.pendiente && verificacion.codigomotivo === MOTIVO_CODIGOS_ESTABLECIMIENTO
  )

export const motivoCodigosEstablecimiento = (
  verificaciones: Array<VerificacionDato> | null | undefined
): VerificacionDato | null => {
  if (!Array.isArray(verificaciones)) return null
  return (
    verificaciones.find(
      (verificacion) =>
        verificacion.pendiente && verificacion.codigomotivo === MOTIVO_CODIGOS_ESTABLECIMIENTO
    ) ?? null
  )
}
